/**
 * arrayMerge: merges the input arrays into a new, unsorted array of unique entries
 */
const arrayMerge = (a: any[] = [], b: any[] = []) => {
  const newArray = ([] as any[]).concat(a, b)
  return [...new Set(newArray)]
}

export default arrayMerge
